import { useCallback, useContext } from "react";
import useStoreArchem from "src/storeArchem";

import { AbilityContext } from "@metronic/_context/Can";
import { MENU_LOGISTICS } from "@src/app/modules/logistics";
import { MENU_NON_RAW_MATS } from "@src/app/modules/non-raw-mats";
import { MENU_RAW_MATS } from "@src/app/modules/raw-mats";
import { MENU_SALES_CONTRACT } from "@src/app/modules/sales-contract";
import { MENU_SYSTEM_MAINTENANCE } from "@src/app/modules/system-maintenance";
import { MENU_TANK_SOUNDING } from "@src/app/modules/tank-sounding";
import { MENU_TRADE_SUMMARY } from "@src/app/modules/trade-summary";

import { ARCHEM_APPS } from "./ArchemApps";

function useAppMenus() {
  const ability = useContext(AbilityContext);
  const setAsideMenu = useStoreArchem(state => state.setAsideMenu);
  const resetAsideMenu = useStoreArchem(state => state.resetAsideMenu);

  const setCurrentApplication = useCallback((applicationName) => {
    const menuLogistics = MENU_LOGISTICS(ability);
    const menuTankSounding = MENU_TANK_SOUNDING(ability);
    const menuRawMats = MENU_RAW_MATS(ability);
    const menuNonRaw = MENU_NON_RAW_MATS(ability);
    const menuSalesContract = MENU_SALES_CONTRACT(ability);
    const menuSystemMaintenance = MENU_SYSTEM_MAINTENANCE(ability);

    switch (applicationName) {
      case ARCHEM_APPS.TRADE_SUMMARY.title:
        setAsideMenu(MENU_TRADE_SUMMARY)
        break;
      case ARCHEM_APPS.LOGISTICS.title:
        setAsideMenu(menuLogistics)
        break;
      case ARCHEM_APPS.TANK_SOUNDING.title:
        setAsideMenu(menuTankSounding);
        break;
      case ARCHEM_APPS.RAW_MATS.title:
        setAsideMenu(menuRawMats);
        break;
      case ARCHEM_APPS.NON_RAW_MATS.title:
        setAsideMenu(menuNonRaw);
        break;
      case ARCHEM_APPS.SALES_CONTRACT.title:
        setAsideMenu(menuSalesContract);
        break;
      case ARCHEM_APPS.SETTINGS.title:
        setAsideMenu(menuSystemMaintenance);
        break;
      default:
        resetAsideMenu();
        break;
    }
  }, [ability])

  return [setCurrentApplication]
}

export default useAppMenus;